import { useDisplayClearBtn } from 'hooks/useDisplayClearBtn'

import { endpoints } from 'modules/endpoints'
import { TableFiltersProps } from 'modules/types'
import { useTranslation } from 'react-i18next'
import { AClearFiltersButton } from 'views/components/Analytics'
import { FiltersAndSearchWrapper, FiltersWrapper } from 'views/components/CommonTableComponents/CommonTableComponents'
import { SearchFilter } from 'views/components/SearchFilter/SearchFilter'
import { ABaseTableFilter } from 'views/components/TableFilters/ABaseTableFilter'
import { defaultListRequestParams } from 'views/components/TableFilters/data'
import { ADateRangePicker } from 'views/components/TableFilters/DateRangePicker/ADateRangePicker'

const DocIndexFilters = ({ listRequestParams, updateFilterState, setListRequestParams }: TableFiltersProps) => {
  const { t } = useTranslation(['documents'])
  const displayClearBtn = useDisplayClearBtn({
    listRequestParams,
  })
  let docTypeEndpoint = endpoints.documentIndexDocumentTypes()
  if (listRequestParams.filter.content_type) {
    docTypeEndpoint = `${docTypeEndpoint}?content_type=${listRequestParams.filter.content_type}`
  }
  return (
    <FiltersAndSearchWrapper>
      <FiltersWrapper>
        <ABaseTableFilter
          onChange={(content_type) => updateFilterState({ content_type })}
          value={listRequestParams.filter.content_type}
          placeholder={t('тип файла')}
          getLabel={(label) => label.name}
          endpoint={endpoints.documentIndexModels()}
          simpleApiFormat
          id="modelFilter"
          showSearch={false}
        />
        <ABaseTableFilter
          onChange={(document_type) => updateFilterState({ document_type })}
          value={listRequestParams.filter.document_type}
          getLabel={(label) => label.name}
          placeholder={t('тип документа')}
          endpoint={docTypeEndpoint}
          simpleApiFormat
          id="documentTypeFilter"
          showSearch={false}
        />
        <ADateRangePicker
          value={[listRequestParams.filter.start_date, listRequestParams.filter.end_date]}
          onChange={(value) => updateFilterState({ start_date: value.startDate, end_date: value.endDate })}
          id="dateFilter"
        />

        {displayClearBtn && (
          <AClearFiltersButton onClick={() => setListRequestParams({ ...defaultListRequestParams })} />
        )}
      </FiltersWrapper>
      <SearchFilter listRequestParams={listRequestParams} updateFilterState={updateFilterState} />
    </FiltersAndSearchWrapper>
  )
}

export default DocIndexFilters
